import config from '../../../config'
export default {
    name: 'factory',
    roles: config.roles
}